import { ready } from "@/lib/ready";
import { on } from "@/lib/dom/on";
import Dialog from "@/lib/easy-dialog";
import { showElement } from "@/lib/dom/showElement";
import { hideElement } from "@/lib/dom/hideElement";
import { toggle } from "@/lib/dom/toggle";
// import "./styles/pop-zip.less"

const initSortBy = () => {

  const input = document.querySelector<HTMLInputElement>(".nearest-input")!;
  const msgElement = document.querySelector<HTMLElement>("#J-nearest-msg")!;
  const sortByNearest = document.querySelector<HTMLElement>(".sort-by-nearest")!;
  const zip = input.value.trim();
  msgElement.innerHTML = ''
  if (zip.length != 5) {
    msgElement.innerHTML = 'Please enter a valid postcode.';
    return;
  }
  const baseurl = sortByNearest.getAttribute('href')!
  const connector = baseurl.lastIndexOf('?') != -1 ? '&' : '?';

  let redirectUrl = '';
  if (baseurl.indexOf("zip=") != -1) {
    redirectUrl = baseurl.replace(/zip=(\d+)/, "zip=" + zip);
  } else {
    redirectUrl = baseurl + connector + "zip=" + zip;
  }
  msgElement.innerHTML = ''
  const url = '/ajax/ZipCode.ashx?action=checkZip&zip=' + zip;
  fetch(url, {
    method: 'GET',

  }).then(res => res.json()).then((res) => {
    if (res.Code == 1) {
      window.location.href = redirectUrl;
    } else {
      msgElement.innerHTML = 'Sorry, we cannot find the postcode you input in our system.Please double check if it\'s the right one. If the postcode is correct, please contact our Reps for help.';
    }
  })
}
ready(() => {

  on('.sort-by-nearest', 'click', (event: MouseEvent) => {
    const { shippingZipCode } = (window as any)
    Dialog.open({
      container: {
        header: " ",
        content: '<style>.easyDialog_wrapper .easyDialog_text{padding:0 15px 5px;}.easyDialog_wrapper .easyDialog_title { background: #fff;border: 0;height: 25px;}.easyDialog_wrapper .easyDialog_content {border-radius: 0;}.popup-zip-wrapper{width:200px;margin: 0 auto;}.popup-zip{ width:370px;min-height:130px;text-align: center; }.popup-zip-msg{color: #ce5959;max-width: 370px; width: 100%;margin-top: 10px;line-height: 1.4;}.popup-zip-tit{  font-size: 17px;color: #003838;font-weight: 600;margin-top: 40px;color: #2a605b;margin-bottom: 10px; }@media (max-width: 768px) {.super-rush-notes {max-height: calc(100vh - 65px);}}</style><div class="popup-zip"><div class="popup-zip-tit">What postcode is this going to?</div><div class="popup-zip-wrapper"><input type="text" class="nearest-input" maxlength="5" placeholder="Enter Postcode" value="' + shippingZipCode + '" /><button type="button" class="nearest-btn">GO</button></div><div id="J-nearest-msg" class="popup-zip-msg"></div></div>'
      },
      drag: true,
      autoClose: 0
    });
    event.preventDefault();

    on('.nearest-btn', 'click', () => {
      initSortBy();
    })
  });


})

ready(() => {
  on(document, 'click', ()=>{
    hideElement('.dropdown-all')

  })
  on(".dropdown-toggle,.dropdown-img", 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement
    const parent = target.parentElement!.querySelector<HTMLElement>(".dropdown-all")! 
    // parent.style.display='block'
    toggle(parent)
    event.stopPropagation()
  })
})